import { render, staticRenderFns } from "./shower.vue?vue&type=template&id=1015920b&scoped=true&"
import script from "./shower.vue?vue&type=script&lang=js&"
export * from "./shower.vue?vue&type=script&lang=js&"
import style0 from "./shower.vue?vue&type=style&index=0&id=1015920b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1015920b",
  null
  
)

export default component.exports